export const STAFF_LIST = 'STAFF_LIST';
export const MENU_LIST = 'MENU_LIST';
export const TREE_DATA = 'TREE_DATA';



// WEBPACK FOOTER //
// ./E:/vue/bh-vue-demo/src/vuex/mutation-types.js